import { NAMESPACE } from '../../constants';

export const BATCH_ORDER = `${NAMESPACE}/BATCH_ORDER`;
export const ORDER_PLAN = `${NAMESPACE}/ORDER_PLAN`;
export const CLEAR_ORDER = `${NAMESPACE}/CLEAR_ORDER`;
